import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import schedule from './schedule/';
import vehicle from './vehicle';
import tires from './tires';
import size from './size';
import location from './location';
import { version } from "../../package.json";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		schedule,
		vehicle,
		size,
		tires,
		location
	},

	plugins: [
		createPersistedState({
			paths: [
				'schedule',
				'tires',
				'vehicle',
				'size',
				'location.selectedStore',
				'location.selectedStoreID',
				'location.selectedStoreRequired',
				'location.selectedStorePending',
				'location.fetchingSelectedStore',
				'location.newLocationID',
				'location.nearestStore',
				'location.nearestStoreRequired',
				'location.unverifiedControlNumber',
				'location.browserGeoPending',
				'location.createdAt',
				'location.forceManualStoreSelection',
			],

			getState: (key, storage) => {
				const savedVersion = localStorage.getItem('vuex-store-version');

				if (savedVersion !== version) {
					console.log('Clearing local storage');
					localStorage.clear();
					localStorage.setItem('vuex-store-version', version);
					return null;
				}

				const rawStorageJSON = storage.getItem(key);

				try {
					const state = JSON.parse(rawStorageJSON);

					return state;
				} catch(e) {
					console.error("Failed to Parse State!");
					console.error(e);

					return null;
				}
			}
		}),
	],
});